import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect, useState } from "react";
import { _postURL } from "@/api/index";
import { Link } from "@/helpers/common_helper";
import { pagelink } from "@/config/site";
import Head from 'next/head';
import Subscription from "@/components/section/subscription";
import { Breadcrumb } from '../components/section/breadcrumb';
import { useRouter } from 'next/router';

export default function Index(props) {
    const { t } = props;
    const [description, setDescription] = useState('');
    
    const currentPage = {
        pageName: t('Privacy_policy'),
        pageLink: useRouter().pathname
    };

    const previousPage = [{}];

    useEffect(async () => {
        // try {
        //     let req = {
        //         "content_id" : 2    // hardcoded content id
        //     }
        //     let result = await _postURL("/api/content", {...req});
        //     setDescription(result.data.content);
        // }
        // catch (error) {
        //     console.log(error);
        // }

    }, []);

    return (
        <>
            <Head>
                <title>{t('Privacy_policy')} | {t('Site_name')}</title>
                <meta name='title' content='Privacy Policy | Ugrado'></meta>
                <meta itemProp='title' content='Privacy Policy | Ugrado'></meta>
                <meta property='og:title' content='Privacy Policy | Ugrado'></meta>
                <meta name='description' content=""></meta>
                <meta itemProp='description' content=""></meta>
                <meta property='og:description' content=""></meta>
                <meta name="keywords" content=""></meta>
            </Head>
            
        <div className="page-content pt-lg-5 pt-2">
            <section className="tnc-sec col-lg-9 col-11 mx-auto pt-3">
                <div className="custom_container2">
                    <div className="row">
                        <div className="col-12">
                            <Breadcrumb 
                                props={ props }
                                currentPage={ currentPage }
                                previousPage={ previousPage }
                            />
                            <div className="tnc-inner">
                                <h1>{t('Privacy_policy')}</h1>

                                <p>It is important for us to protect your privacy and data rights at all times. By visiting Our 
                                    Website and using Our Services, You acknowledge reading and fully considering this 
                                    Privacy & Data Policy. On this page, you will find information about how we process 
                                    personal data to provide the safest, most enjoyable experience possible. Hope you enjoy Our site!</p>
                                <h2 className='custom_colorSecondary'>
                                    1. Cookies Policy
                                </h2>
                                <p>
                                    A cookie is a small file of letters and numbers that we put on your computer. Cookies allow us 
                                    to distinguish you from other users which helps us to provide you with a good browsing experience. 
                                    Ugrado uses our own Google Analytics, Facebook TikTok pixel and Youtube cookies to store and access 
                                    information such as unique IDs to deliver, maintain and improve our services and provide you a superior 
                                    browsing experience. You can select 'I accept all cookies' to consent to these uses and confirm that 
                                    you agree with your cookie information. You can always personalise your cookie settings.</p>
                                <h2 className='custom_colorSecondary'>
                                    2. Privacy Policy
                                </h2>
                                <p>
                                    We take our customer's privacy seriously! Ugrado will not use any of the information on this form that 
                                    has been provided by you for any purpose other than contact or mailing of product information and 
                                    general correspondence and/or special offers. We will keep your personal data for as long as we need it 
                                    for the purposes for which it was collected.</p>
                                <h2 className='custom_colorSecondary'>
                                    3. Confidentiality
                                </h2>
                                <p>
                                    Your Personal Data is processed solely by authorised personnel of the Company, bound by strict obligations 
                                    of confidentiality. For these purposes, the information may be stored, and processed but never be passed 
                                    on to any third-party companies.</p>
                                
                                <p>Should you have any queries, objections, or complaints about the processing of your personal data for the 
                                    Optional Purposes or if you wish to withdraw consents which you have provided voluntarily, please contact 
                                    us in writing using this contact detail care@ugrado.com</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
            {/* <section className="privacy-policy-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item" style={{ textTransform: "uppercase"}}><Link href={pagelink.home.homepage}>{t('Home')}</Link></li>
                                <li className="breadcrumb-item active" style={{ textTransform: "uppercase"}} aria-current="page">{t('Privacy_policy')}</li>
                            </ol>
                            <div className="privacy-policy-inner">
                                <h3>{t('Privacy_policy')}</h3>
                                <div className="text-box">
                                    <span dangerouslySetInnerHTML={{ __html: description }}></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            {/** Subscription Part */}
            <Subscription {...props}/>
        </>
    )
}

export async function getStaticProps(data) {
    return {
        props: {
            ...(await serverSideTranslations(data.locale, ['common'])),
        },
    };
}